import React, { ReactElement, ReactNode, useContext } from 'react';
import { IDeprecatedWorkspaceAction, IWorkspaceAction } from '../../@types/workspaceTypes';
import { WorkspaceActionHeader } from '../../components/ActionButtons/ActionHeader';
import { PurchaseOrderExportToEdi } from '../../graphql/mutations/purchases/PurchaseOrderExportToEdi.graphql';
import { useBackgroundMutation } from '../../utils/BackgroundJobs';
import WorkspaceContext from '../../components/Context/WorkspaceContext';
import getClientMutationId from '../../utils/getClientMutationId';
import {
  IPurchaseOrderExportToEdiMutationResult,
  IPurchaseOrderExportToEdiMutationVariables,
} from '../../graphql/schema/p4types';
import { useActionCriteria } from '../../utils/useActionProps';

export enum PurchaseOrderWorkspaceActions {
  ExportToEdi = 'Export to Edi',
}

export const workspaceForPermission = [
  {
    description: 'Export to Edi',
    actionReference: 'EXPORT_PO_TO_EDI',
  },
];

export const usePurchaseOrderWorkspaceActions: () => [
  Array<IWorkspaceAction | IDeprecatedWorkspaceAction>,
  ReactNode | ReactElement
] = () => {
  const workspace = useContext(WorkspaceContext);
  const actionCriteria = useActionCriteria();
  const [exportToEdiMutation] = useBackgroundMutation<
    IPurchaseOrderExportToEdiMutationResult,
    IPurchaseOrderExportToEdiMutationVariables
  >(PurchaseOrderExportToEdi, {
    onCompleteJob: (jobInfo) => {
      if (jobInfo.properties?.reportFile) {
        const reportFileNames = jobInfo.properties.reportFile.split(';');
        reportFileNames.forEach((fileName) => window.open(`/api/resources/temporary/${fileName}`, '_blank'));
        workspace.reloadData?.();
      }
    },
  });

  const exportToEdi = {
    key: 'purchaseOrderEdi',
    text: 'Export to Edi',
    onClick: () =>
      exportToEdiMutation({
        variables: {
          input: {
            clientMutationId: getClientMutationId(),
            actionCriteria,
          },
        },
      }),
    actionReference: 'EXPORT_PO_TO_EDI',
    header: WorkspaceActionHeader.REPORTS,
    errorMessage: 'Could not export to EDI',
  };

  return [[exportToEdi], <></>];
};
